import { crearVariables } from "./crearVariables";

/**
 * Carga todos los assets del juego de la ruleta
 * @param {*} scene 
 */
export function creacionParametrosPrincipal(scene) {

  crearVariables(scene);

}